import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import Loader from '../utility/Loader';
import authservice from '../Authentication/service/authservice';
import LargeRectangle from '../advertisements/LargeRectangle';
import debounce from 'lodash/debounce';
import ClipContentMob from './ClipContentMob';
import ClipAds from '../advertisements/ClipAds';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

class ClipListingMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clipCache: [],
            currentIndex: 0,
            activeSlide: 1,
            translateY: 0,
            animating: false,
            startY: 0,
            error: null,
            showAd: false,
            numberOfDownSwap: 1,
            loading: true,
        };
        this.startY = 0; // <-- Add this line
        //this.handleTouchEndDebounced = debounce(this.handleTouchEnd, 50);
    }

    preventScroll = function (e) {
        if (e.touches.length > 1) return;
        e.preventDefault();
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.callClipDetails(this.props.match.params.hpId);
        // window.addEventListener('touchstart', this.handleTouchStart);
        //window.addEventListener('touchend', this.handleTouchEnd);
        window.addEventListener('touchmove', this.preventScroll, { passive: false });
        // window.addEventListener('touchmove', function (e) {
        //     if (e.touches.length > 1) return; // allow pinch zoom
        //     e.preventDefault();
        // }, { passive: false });

        // const container = document.querySelector('.clip-viewport');
        // if (container) {
        //     container.addEventListener('touchmove', this.preventScroll, { passive: false });
        // }

    }

    componentWillUnmount() {
        //window.removeEventListener('touchstart', this.handleTouchStart);
        //window.removeEventListener('touchend', this.handleTouchEnd);
        clearTimeout(this.timer);
        window.removeEventListener('touchmove', this.preventScroll);
        // const container = document.querySelector('.clip-viewport');
        // if (container) {
        //     container.removeEventListener('touchmove', this.preventScroll);
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.currentIndex !== prevState.currentIndex) {
            window.scrollTo(0, 0);
        }
    }

    handleTouchStart = (e) => {
        if (this.state.animating) return;
        this.setState({ startY: e.touches[0].clientY });
    };

    handleTouchMove = (e) => {
        if (this.state.animating) return;

        const deltaY = e.touches[0].clientY - this.state.startY;
        this.setState({ translateY: deltaY }); // move clip as finger moves
    };

    getClipWithAds = () => {
        const { clipCache } = this.state;
        const clipWithAds = [];

        clipCache.forEach((clip, index) => {
            clipWithAds.push({ type: 'clip', data: clip });
            if ((index + 1) % 5 === 0) {
                clipWithAds.push({ type: 'ad', data: null });
            }
        });

        return clipWithAds;
    };


    handleTouchEnd = (e) => {
        const { translateY, currentIndex, clipCache } = this.state;
        const clipWithAds = this.getClipWithAds();

        const threshold = 100; // minimum px to trigger swipe

        let isSwiped = false;

        // This is to prevent the default browser refresh when swiping down
        if (e && e.cancelable && (translateY > threshold || translateY < -threshold)) {
            e.preventDefault();
            isSwiped = true;
        }


        if (translateY < -threshold && currentIndex < clipWithAds.length - 1) {
            // Swipe Up → Next Clip
            this.setState({ animating: true, translateY: -window.innerHeight }, () => {
                setTimeout(() => {
                    this.setState({
                        currentIndex: currentIndex + 1,
                        translateY: 0,
                        animating: false,
                    }, () => {
                        if (this.state.currentIndex === this.state.clipCache.length - 1) {
                            this.fetchClipFromServer();
                        }
                        this.updateURL();
                    });
                }, 300);
            });
        } else if (translateY > threshold && currentIndex > 0) {
            // Swipe Down → Prev Clip
            this.resetAllVideos();
            this.setState({ animating: true, translateY: window.innerHeight }, () => {
                setTimeout(() => {
                    this.setState({
                        currentIndex: currentIndex - 1,
                        translateY: 0,
                        animating: false,
                    }, this.updateURL);
                }, 300);
            });
        } else {
            // Not enough movement → Snap back
            this.setState({ animating: true, translateY: 0 }, () => {
                setTimeout(() => this.setState({ animating: false }), 300);
            });
        }

        if (isSwiped) {
            // Only if a swipe was detected, we prevent the event
            e.preventDefault();
        }
    };

    updateURL = () => {
        const clipWithAds = this.getClipWithAds();
        const { currentIndex } = this.state;
        const currentItem = clipWithAds[currentIndex];

        if (currentItem && currentItem.type === 'clip') {
            const clipListing = currentItem.data.clipListing;
            if (clipListing && clipListing.businessName) {
                const businessName = clipListing.businessName.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-');
                this.props.history.push(`/clips/${businessName}/${clipListing.hpId}`);
            }
        }
    };


    callClipDetails = (hpId) => {
        this.setState({ loading: true });
        const url = `${process.env.REACT_APP_BACKEND_URL}/hpmgr/listing/getlistings/${hpId}?${this.props.is_login ? 'user_id=' + authservice.getCurrentUserid() : 'guest_id=' + authservice.getCookie('hp.rocks.soon')}`;

        axios.get(url)
            .then(response => {
                const clipCache = [];
                clipCache.push({
                    clipListing: response.data,
                    subCategories: response.data.subCategories
                });
                this.setState({ clipCache }, () => this.fetchClipFromServer()); // Call loadNextClip after setting initial clip data
            })
            .catch(error => {
                Loader.stopSpinner();
                if (error.response)
                    this.setState({ error: error.response.data });
            });
    }

    fetchClipFromServer = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/hpmgr/listing/get-next-clips?${this.props.is_login ? 'user_id=' + authservice.getCurrentUserid() : 'guest_id=' + authservice.getCookie('hp.rocks.soon')}`)
            .then(response => {
                const nextClipListing = response.data;
                sessionStorage.removeItem("clipad")
                if (nextClipListing && nextClipListing.subCategories && nextClipListing.subCategories.length > 0) {
                    const nextClipData = {
                        clipListing: nextClipListing,
                        subCategories: nextClipListing.subCategories
                    };
                    this.setState(prevState => ({
                        clipCache: [...prevState.clipCache, nextClipData],
                        loading: false // <-- done loading
                    }));
                } else {
                    console.log("No next clips available.");
                }
            })
            .catch(error => {
                Loader.stopSpinner();
                console.error('Error fetching next clip:', error);
                if (error.response)
                    this.setState({ error: error.response.data });
            });
    }

    resetAllVideos = () => {
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            if (!video) return;

            const container = video.closest('.clip-container');
            const isVisible = container && container.offsetTop === window.scrollY;

            if (!isVisible) {
                video.pause();
                video.muted = true;
                video.currentTime = 0;
            }
        });
    };


    render() {
        const clipWithAds = this.getClipWithAds();
        return (
            <div className='clipListingMobile'>
                {this.state.loading ? (
                    <div className="video-buffering-spinner">
                        <i className="fa fa-spinner fa-spin" style={{
                            fontSize: '30px',
                            color: 'white',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 5
                        }}></i>
                    </div>
                ) :
                    (this.state.showAd
                        ?
                        <>
                            <div style={{ position: 'absolute', top: '18px', left: '18px' }}>
                                <Link to='/' style={{ position: 'absolute' }}><i style={{ fontSize: '45px' }} className="fa fa-home home_link styled-icon"></i></Link>
                            </div>
                            {/* <div className='text-center'> */}
                            <ClipAds spot={"-1"} />
                            {/* </div> */}
                        </>
                        :
                        <div className="clip-viewport"
                            onTouchStart={this.handleTouchStart}
                            onTouchMove={this.handleTouchMove}
                            onTouchEnd={this.handleTouchEnd}
                        >
                            <div className="clip-wrapper"
                                style={{
                                    transform: `translateY(calc(-${this.state.currentIndex * 100}vh + ${this.state.translateY}px))`,
                                    transition: this.state.animating ? 'transform 0.3s ease' : 'none',
                                }}
                            >
                                {clipWithAds.map((item, index) => (
                                    <div className="clip-container" key={index}>
                                        {item.type === 'clip' ? (
                                            <ClipContentMob key={item.data.clipListing.hpId} listing={item.data.clipListing} isActive={index === this.state.currentIndex} />
                                        ) : (
                                            <ClipAds spot={`ad-${index}`} isActive={index === this.state.currentIndex} />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                    )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        is_login: state.is_login,
        listing_id: state.listing_id,
        viewedListings: state.viewedListings,
        search_data: state.search_data,
        clipadAds: state.clipadAds,
    };
};

export default connect(mapStateToProps)(ClipListingMobile);
